import React from "react";
import { Accordion } from "react-bootstrap";

import { ModuleClass } from "./ModuleClass";
import { ModuleExam } from "./ModuleExam";
import { useCourseModule } from "../hooks/useCourseModule";

export function CourseModule({
  courseModules,
  courseModule,
  moduleIndex,
}) {
  const {
    moduleQuizAdvance,
    previousModuleQuizAdvance,
  } = useCourseModule({
    courseModules,
    courseModule,
    moduleIndex,
  });

  const classes = courseModule?.classes || [];
  const lessonCount = classes.length;

  return (
    <Accordion.Item
      eventKey={String(courseModule.id)}
      className="modern-module-card"
    >
      <Accordion.Header>
        <div className="modern-module-header">

          <div className="modern-module-number">
            {String(moduleIndex + 1).padStart(2, "0")}
          </div>

          <div className="modern-module-title">
            <span>MÓDULO {moduleIndex + 1}</span>
            <strong>{courseModule?.title}</strong>
          </div>

          <div className="modern-module-meta">
            <span>
              <i className="far fa-file-alt" />
              {lessonCount} {lessonCount === 1 ? "tema" : "temas"}
            </span>

            {courseModule.quizId && (
              <span>
                <i className="far fa-check-square" />
                Evaluación
              </span>
            )}
          </div>

        </div>
      </Accordion.Header>

      <Accordion.Body>
        <div className="modern-module-lessons">

          {classes.map((moduleClass, moduleClassIndex) => (
            <ModuleClass
              key={moduleClass.id}
              previousModuleQuizAdvance={previousModuleQuizAdvance}
              prevCourseModule={courseModules[moduleIndex - 1]}
              courseModule={courseModule}
              moduleClass={moduleClass}
              moduleIndex={moduleIndex}
              moduleClassIndex={moduleClassIndex}
            />
          ))}

          {courseModule.quizId && (
            <div className="modern-module-exam">
              <div className="modern-module-exam-label">
                <i className="fas fa-clipboard-check" />
                <span>Evaluación del módulo</span>
              </div>

              <ModuleExam
                moduleQuizAdvance={moduleQuizAdvance}
                courseModule={courseModule}
              />
            </div>
          )}

        </div>
      </Accordion.Body>
    </Accordion.Item>
  );
}
